/* @flow */

export {Truncated} from './truncated';
export {TruncatedElement} from './truncated-element';
